/* =============================================================================
   Keuzehulp – Koekenpan wizard (Woerdman Kookkado)
   Haalt de echte producten op uit de collectie en filtert op tags.
   ============================================================================= */
(function () {
  'use strict';

  /* ── Stap-definities ─────────────────────────────────────────────────── */
  var STEPS = [
    { id:'warmtebron', q:'Waar kook je op?', type:'tiles', cols3:true, options:[
        { v:'gas',        label:'Gas',        desc:'Bijna elke pan werkt op gas.',                                  il:'gas',        tags:['pannen-gas'] },
        { v:'inductie',   label:'Inductie',   desc:'Niet elke pan is inductiegeschikt, wij filteren de juiste eruit.', il:'inductie', tags:['pannen-inductie'] },
        { v:'elektrisch', label:'Elektrisch', desc:'Ook keramische en halogeen kookplaten.',                        il:'elektrisch', tags:[] }
    ]},
    { id:'personen', q:'Voor hoeveel mensen kook je meestal?', hint:'Zo schatten we in welk formaat pan handig is.', type:'tiles', cols3:true, options:[
        { v:'klein',  label:'Vooral voor mezelf', desc:'Een kleine pan (tot 22 cm), fijn voor een ei of één portie.', il:'p1', tags:['koekenpannen-18-cm','koekenpannen-20-cm','koekenpannen-22-cm'] },
        { v:'middel', label:'Voor 2 à 3 personen', desc:'Een middelgrote pan (24 tot 26 cm) voor doordeweeks koken.', il:'p2', tags:['koekenpannen-24-cm','koekenpannen-26-cm'] },
        { v:'groot',  label:'Voor 4 of meer',      desc:'Een grote pan (28 cm of meer) voor het hele gezin.',         il:'p4', tags:['koekenpannen-28-cm','koekenpannen-30-cm','koekenpannen-32-cm'] }
    ]},
    { id:'gebruik', q:'Hoe kook je het liefst?', hint:'Hieraan zien we welke laag het beste bij je past.', type:'tiles', options:[
        { v:'antikleef', label:'Bakken zonder plakken', desc:'Met antikleeflaag: niks plakt en je hebt weinig vet nodig. Fijn voor ei, vis en pannenkoek.', il:'egg',  tags:['pannen-keramisch','pannen-anti-aanbak','koekenpannen-anti-aanbak','koekenpannen-keramisch'] },
        { v:'rvs',       label:'Lekker dichtschroeien',  desc:'RVS zonder laag: perfect aanbraden en een mooie korst. Voor de liefhebber.',                 il:'sear', tags:['pannen-rvs','koekenpannen-rvs'] },
        { v:null,        label:'Geen voorkeur',          desc:'Dan laten we pannen met én zonder antikleeflaag zien.',                                        il:'any',  tags:[] }
    ]},
    { id:'oven', q:'Wil je de pan ook in de oven kunnen gebruiken?', type:'list', options:[
        { v:'ja',   label:'Ja, dat is handig', tags:['pannen-oven'] },
        { v:null,   label:'Nee, dat hoeft niet', tags:[] }
    ]},
    { id:'budget', q:'Heb je een budget in gedachten?', type:'list', options:[
        { v:'b1', label:'Tot € 50',      max:50 },
        { v:'b2', label:'€ 50 tot € 75',  min:50, max:75 },
        { v:'b3', label:'€ 75 tot € 100', min:75, max:100 },
        { v:'b4', label:'€ 100 of meer', min:100 },
        { v:null, label:'Geen voorkeur' }
    ]}
  ];

  /* ── Illustraties ────────────────────────────────────────────────────── */
  var wrap = function (inner) { return '<svg viewBox="0 0 120 68" width="100%" height="100%"><rect x="6" y="6" width="108" height="56" rx="8" fill="#0B0531" opacity=".06"/>' + inner + '</svg>'; };
  var IL = {
    gas:        wrap('<path d="M60 20c6 6 9 11 9 17a9 9 0 0 1-18 0c0-3.4 1.5-6.2 3.8-8.4.9 3.2 2.5 4 3.8 4-2.5-4.6.3-9 1.6-12.6z" fill="#C7642F"/><path d="M60 34c2.4 2.4 3.4 4.6 3.4 6.8a3.8 3.8 0 0 1-7 1.6c1.6 0 2.6-1.4 2-3.6.8-.6 1.4-2 1.6-4.8z" fill="#FFFFFF" opacity=".55"/>'),
    inductie:   wrap('<circle cx="46" cy="34" r="12" fill="none" stroke="#C7642F" stroke-width="2.4"/><circle cx="46" cy="34" r="6" fill="none" stroke="#C7642F" stroke-width="2.4"/><circle cx="80" cy="34" r="10" fill="none" stroke="#0B0531" stroke-width="2" opacity=".35"/>'),
    elektrisch: wrap('<circle cx="60" cy="34" r="16" fill="none" stroke="#0B0531" stroke-width="2" stroke-opacity=".28"/><path d="M52 33a4 4 0 0 1 8 0 4 4 0 0 0 8 0" fill="none" stroke="#C7642F" stroke-width="2.6" stroke-linecap="round"/><path d="M52 39a4 4 0 0 1 8 0 4 4 0 0 0 8 0" fill="none" stroke="#C7642F" stroke-width="2.6" stroke-linecap="round" opacity=".55"/>'),
    p1: wrap('<circle cx="60" cy="26" r="7" fill="#C7642F"/><path d="M49 49c0-7 5-11 11-11s11 4 11 11z" fill="#C7642F"/>'),
    p2: wrap('<circle cx="38" cy="26" r="7" fill="#C7642F"/><path d="M27 49c0-7 5-11 11-11s11 4 11 11z" fill="#C7642F"/><circle cx="60" cy="26" r="7" fill="#0B0531" opacity=".4"/><path d="M49 49c0-7 5-11 11-11s11 4 11 11z" fill="#0B0531" opacity=".4"/><circle cx="82" cy="26" r="7" fill="#0B0531" opacity=".4"/><path d="M71 49c0-7 5-11 11-11s11 4 11 11z" fill="#0B0531" opacity=".4"/>'),
    p4: wrap('<g fill="#C7642F"><circle cx="28" cy="27" r="6.5"/><path d="M18 49c0-6.5 4.5-10.5 10-10.5s10 4 10 10.5z"/></g><g fill="#0B0531" opacity=".4"><circle cx="49" cy="27" r="6.5"/><path d="M39 49c0-6.5 4.5-10.5 10-10.5s10 4 10 10.5z"/><circle cx="70" cy="27" r="6.5"/><path d="M60 49c0-6.5 4.5-10.5 10-10.5s10 4 10 10.5z"/><circle cx="91" cy="27" r="6.5"/><path d="M81 49c0-6.5 4.5-10.5 10-10.5s10 4 10 10.5z"/></g>'),
    egg: wrap('<circle cx="55" cy="35" r="21" fill="#332E45"/><circle cx="55" cy="35" r="21" fill="none" stroke="#0B0531" stroke-width="2.4" stroke-opacity=".5"/><ellipse cx="55" cy="29" rx="14" ry="3.6" fill="#FFFFFF" opacity=".08"/><path d="M76 35h19" stroke="#0B0531" stroke-width="5" stroke-linecap="round" stroke-opacity=".5"/><ellipse cx="53" cy="36" rx="11.5" ry="9" fill="#FFFFFF"/><circle cx="53" cy="35" r="5.6" fill="#EC9430"/><circle cx="50.6" cy="32.6" r="1.9" fill="#FBCB86"/>'),
    sear: wrap('<circle cx="55" cy="37" r="21" fill="#DDD8E2"/><circle cx="55" cy="37" r="21" fill="none" stroke="#0B0531" stroke-width="2.4" stroke-opacity=".45"/><path d="M76 37h19" stroke="#0B0531" stroke-width="5" stroke-linecap="round" stroke-opacity=".45"/><ellipse cx="54" cy="38.5" rx="13" ry="8.8" fill="#A5613D"/><ellipse cx="54" cy="35.5" rx="12.6" ry="4.2" fill="#B87A52"/><path d="M45 38l18 2M47 42l16-2" stroke="#5C3320" stroke-width="1.5" stroke-opacity=".5"/><path d="M46 22c1.4 3-1.4 5 0 8" fill="none" stroke="#C7642F" stroke-width="2.2" stroke-linecap="round" opacity=".6"/><path d="M58 19c1.4 3-1.4 5 0 8" fill="none" stroke="#C7642F" stroke-width="2.2" stroke-linecap="round" opacity=".6"/><path d="M70 22c1.4 3-1.4 5 0 8" fill="none" stroke="#C7642F" stroke-width="2.2" stroke-linecap="round" opacity=".45"/>'),
    any: wrap('<rect x="49" y="22" width="10" height="10" rx="3" fill="#C7642F"/><rect x="63" y="22" width="10" height="10" rx="3" fill="#0B0531" opacity=".38"/><rect x="49" y="36" width="10" height="10" rx="3" fill="#0B0531" opacity=".38"/><rect x="63" y="36" width="10" height="10" rx="3" fill="#0B0531" opacity=".38"/>')
  };

  var CHECK='<svg width="11" height="11" viewBox="0 0 14 14" fill="none"><path d="M11.5 3.5L5.25 10.5 2.5 7.6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var MINUS='<svg width="11" height="11" viewBox="0 0 14 14" fill="none"><path d="M3.5 7h7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var ARROW='<svg width="17" height="17" viewBox="0 0 24 24" fill="none"><path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var XICON='<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M14 4L4 14M4 4l10 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  /* ── State ───────────────────────────────────────────────────────────── */
  var handle = 'koekenpannen';
  var products = null, loading = false;
  var state = { screen:'intro', i:0, a:{}, showAll:false };
  var app, root, lastFocus;

  var euroFmt = new Intl.NumberFormat('nl-NL', { style:'currency', currency:'EUR' });
  function esc(s){ var d=document.createElement('div'); d.textContent=s==null?'':s; return d.innerHTML; }
  function euro(n){ return euroFmt.format(n).replace(/ /g,' '); }
  function hasAny(tags, list){ for(var i=0;i<list.length;i++){ if(tags.indexOf(list[i])>-1) return true; } return false; }

  /* ── Producten ophalen ───────────────────────────────────────────────── */
  function loadProducts(){
    loading = true;
    var all = [], page = 1;
    function next(){
      fetch('/collections/'+handle+'/products.json?limit=250&page='+page)
        .then(function(r){ if(!r.ok) throw 0; return r.json(); })
        .then(function(d){
          var batch = (d && d.products) || [];
          batch.forEach(function(p){
            var v = (p.variants && p.variants[0]) || {};
            var img = (p.images && p.images[0] && p.images[0].src) || (p.featured_image || '');
            all.push({
              title: p.title,
              brand: p.vendor || '',
              handle: p.handle,
              url: '/products/' + p.handle,
              price: parseFloat(v.price || '0'),
              compare: parseFloat(v.compare_at_price || '0'),
              img: img,
              tags: (p.tags || []).map(function(t){ return String(t).toLowerCase(); })
            });
          });
          if(batch.length === 250){ page++; next(); }
          else { products = all; loading = false; if(state.screen==='results') render(); }
        })
        .catch(function(){ products = []; loading = false; if(state.screen==='results') render(); });
    }
    next();
  }

  /* ── Filteren ────────────────────────────────────────────────────────── */
  function budgetOf(v){ return STEPS[4].options.filter(function(o){ return o.v===v; })[0]; }
  function matches(p){
    var a = state.a;
    // tag-stappen
    ['warmtebron','personen','gebruik','oven'].forEach(function(){});
    var stepIds = ['warmtebron','personen','gebruik','oven'];
    for(var i=0;i<stepIds.length;i++){
      var id = stepIds[i]; if(!(id in a)) continue;
      var step = STEPS.filter(function(s){ return s.id===id; })[0];
      var opt = step.options.filter(function(o){ return o.v===a[id]; })[0];
      if(opt && opt.tags && opt.tags.length && !hasAny(p.tags, opt.tags)) return false;
    }
    if(a.budget){ var b=budgetOf(a.budget); if(b){ if(b.min && p.price<b.min) return false; if(b.max && p.price>b.max) return false; } }
    return true;
  }

  function crits(){
    var a = state.a, out = [];
    if(a.warmtebron==='inductie') out.push({ tags:['pannen-inductie'], label:'Geschikt voor inductie' });
    if(a.personen){ var pOpt=STEPS[1].options.filter(function(o){return o.v===a.personen;})[0];
      out.push({ tags:pOpt.tags, label:{klein:'Kleine pan',middel:'Middelgrote pan',groot:'Grote pan'}[a.personen] }); }
    if(a.gebruik){ var gOpt=STEPS[2].options.filter(function(o){return o.v===a.gebruik;})[0];
      out.push({ tags:gOpt.tags, label:a.gebruik==='rvs'?'RVS voor aanbraden':'Met antikleeflaag' }); }
    if(a.oven==='ja') out.push({ tags:['pannen-oven'], label:'Ovengeschikt' });
    if(a.budget){ var b=budgetOf(a.budget); out.push({ budget:b, label:'Past in budget' }); }
    return out;
  }
  function meets(p,c){
    if(c.budget){ var b=c.budget; return (!b.min||p.price>=b.min)&&(!b.max||p.price<=b.max); }
    return hasAny(p.tags, c.tags);
  }
  function score(p){ return crits().reduce(function(t,c){ return t+(meets(p,c)?1:0); },0); }

  /* ── Render ──────────────────────────────────────────────────────────── */
  function render(){
    if(state.screen==='intro') return intro();
    if(state.screen==='results') return results();
    step();
  }

  function intro(){
    root.innerHTML =
      '<div class="kh-intro">'+
        '<p class="kh-eyebrow">Keuzehulp</p>'+
        '<h1 class="kh-serif">Welke koekenpan past bij jou?</h1>'+
        '<p class="kh-intro-p">Beantwoord vijf korte vragen over hoe jij kookt, dan zoeken wij de best passende pannen voor je uit.</p>'+
        '<div class="kh-meta"><span><span class="kh-dot">●</span> 5 korte vragen</span><span><span class="kh-dot">●</span> ± 1 minuut</span><span><span class="kh-dot">●</span> vrijblijvend</span></div>'+
        '<button class="kh-btn" data-act="start">Start de keuzehulp</button>'+
      '</div>';
  }

  function tileHtml(step,o){
    var sel = state.a[step.id]===o.v || (o.v===null && (step.id in state.a) && state.a[step.id]===null);
    return '<button class="kh-tile'+(sel?' sel':'')+'" data-v="'+(o.v===null?'__null__':o.v)+'">'+
      '<span class="kh-media">'+(IL[o.il]||'')+'</span>'+
      '<span class="kh-tb"><span class="kh-tlabel">'+esc(o.label)+'<span class="a">'+ARROW+'</span></span>'+
      (o.desc?'<span class="kh-tdesc">'+esc(o.desc)+'</span>':'')+'</span></button>';
  }
  function optHtml(step,o){
    var sel = state.a[step.id]===o.v || (o.v===null && (step.id in state.a) && state.a[step.id]===null);
    return '<button class="kh-opt'+(sel?' sel':'')+'" data-v="'+(o.v===null?'__null__':o.v)+'">'+
      '<span class="kh-opt-main"><span class="kh-opt-label">'+esc(o.label)+'</span>'+
      (o.desc?'<span class="kh-opt-desc">'+esc(o.desc)+'</span>':'')+'</span>'+
      '<span class="kh-arrow">'+ARROW+'</span></button>';
  }

  function step(){
    var s = STEPS[state.i];
    var pct = Math.round(state.i/STEPS.length*100)+7;
    var inner = s.type==='tiles'
      ? '<div class="kh-tiles'+(s.cols3?' cols3':'')+'">'+s.options.map(function(o){return tileHtml(s,o);}).join('')+'</div>'
      : '<div class="kh-opts">'+s.options.map(function(o){return optHtml(s,o);}).join('')+'</div>';
    var left = state.i>0 ? '<button class="kh-lnk" data-act="back">← Vorige</button>' : '<span></span>';
    root.innerHTML =
      '<div class="kh-top"><span class="kh-step">Vraag '+(state.i+1)+' van '+STEPS.length+'</span>'+
        '<span class="kh-track"><span class="kh-fill" style="width:'+pct+'%"></span></span>'+
        '<button class="kh-x" data-act="close" aria-label="Sluiten">'+XICON+'</button></div>'+
      '<div class="kh-body"><h2 class="kh-q kh-serif">'+esc(s.q)+'</h2>'+
        (s.hint?'<p class="kh-hint">'+esc(s.hint)+'</p>':'')+inner+'</div>'+
      '<div class="kh-foot">'+left+'<button class="kh-lnk muted" data-act="restart">Opnieuw beginnen</button></div>';
  }

  function reasonHtml(p){
    var html = crits().map(function(c){
      var ok = meets(p,c);
      return '<span class="kh-reason '+(ok?'ok':'no')+'"><span class="ic">'+(ok?CHECK:MINUS)+'</span>'+esc(c.label)+'</span>';
    }).join('');
    if(hasAny(p.tags,['pannen-pfas-vrij','koekenpannen-zonder-pfas']))
      html += '<span class="kh-reason ok"><span class="ic">'+CHECK+'</span>PFAS-vrij</span>';
    var mat = hasAny(p.tags,['pannen-rvs','koekenpannen-rvs']) ? 'Ideaal voor aanbraden' : 'Weinig vet nodig';
    html += '<span class="kh-reason ok"><span class="ic">'+CHECK+'</span>'+mat+'</span>';
    return html;
  }

  function cardHtml(p,best){
    var price = '<span class="kh-rprice">'+euro(p.price)+(p.compare>p.price?'<span class="was">'+euro(p.compare)+'</span>':'')+'</span>';
    return '<div class="kh-rcard'+(best?' best':'')+'">'+
      (best?'<span class="kh-badge">Beste match</span>':'')+
      '<div class="kh-rrow">'+
        '<div class="kh-rimg">'+(p.img?'<img src="'+p.img+'" alt="" loading="lazy">':'')+'</div>'+
        '<div class="kh-rmid"><div class="kh-rbrand">'+esc(p.brand)+'</div>'+
          '<div class="kh-rname">'+esc(p.title)+'</div>'+price+
          '<span class="kh-rcta"><a class="kh-btn" href="'+p.url+'">Bekijk deze pan '+ARROW+'</a></span></div>'+
      '</div>'+
      '<div class="kh-reasons">'+reasonHtml(p)+'</div>'+
    '</div>';
  }

  function results(){
    if(loading || products===null){
      root.innerHTML = '<div class="kh-top"><span class="kh-step">Even zoeken…</span><span class="kh-track"><span class="kh-fill" style="width:100%"></span></span><button class="kh-x" data-act="close" aria-label="Sluiten">'+XICON+'</button></div>'+
        '<div class="kh-body"><div class="kh-loading"><div class="kh-spin"></div><p>We zoeken de beste pannen voor jou…</p></div></div>';
      return;
    }
    var exact = products.filter(matches);            // in collectie-volgorde (bestsellers eerst)
    var count = exact.length;
    var none = count===0;
    var list;
    if(none){
      list = products.map(function(p){ return {p:p,n:score(p)}; }).sort(function(x,y){ return y.n-x.n; }).slice(0,3).map(function(r){return r.p;});
    } else {
      list = state.showAll ? exact : exact.slice(0,3);
    }
    var cards = list.map(function(p,idx){ return cardHtml(p, idx===0); }).join('');
    var sum = none
      ? 'Geen pan voldoet aan al je wensen. Deze komen het dichtst in de buurt:'
      : (count===1 ? 'We vonden <b>1 pan</b> die bij je past:' : 'We vonden <b>'+count+' pannen</b> die bij je passen'+(count>3&&!state.showAll?'. Dit zijn de 3 beste:':':'));
    var more = (!none && count>3)
      ? (state.showAll
          ? '<p class="kh-all"><a href="#" data-act="less">Toon minder ↑</a></p>'
          : '<p class="kh-all"><a href="#" data-act="all">Bekijk alle '+count+' passende pannen '+ARROW+'</a></p>')
      : '';
    root.innerHTML =
      '<div class="kh-top"><span class="kh-step">Klaar</span><span class="kh-track"><span class="kh-fill" style="width:100%"></span></span>'+
        '<button class="kh-x" data-act="close" aria-label="Sluiten">'+XICON+'</button></div>'+
      '<div class="kh-body"><div class="kh-res-head"><p class="kh-res-eyebrow">Onze aanbeveling</p>'+
        '<h2 class="kh-res-h kh-serif">'+(none?'Deze komen het dichtst in de buurt':'Dit past het beste bij jou')+'</h2>'+
        '<p class="kh-res-sum">'+sum+'</p></div>'+
        (count<3?'<div class="kh-note">Wil je meer keuze? Verruim je budget of formaat.</div>':'')+
        '<div class="kh-cards">'+cards+'</div>'+more+'</div>'+
      '<div class="kh-foot"><button class="kh-lnk" data-act="back">← Vorige</button>'+
        '<button class="kh-lnk muted" data-act="restart">Opnieuw beginnen</button></div>';
  }

  /* ── Interactie ──────────────────────────────────────────────────────── */
  function choose(s,raw){ state.a[s.id] = (raw==='__null__') ? null : raw; step(); setTimeout(advance,170); }
  function advance(){ state.showAll=false; if(state.i<STEPS.length-1){ state.i++; render(); } else { state.screen='results'; render(); } }
  function toIntro(){ state.screen='intro'; state.a={}; state.i=0; state.showAll=false; render(); }

  function onClick(e){
    var t = e.target.closest('[data-act],[data-v]');
    if(!t) return;
    var act = t.getAttribute('data-act');
    if(t.hasAttribute('data-v')){
      var s = STEPS[state.i]; choose(s, t.getAttribute('data-v')); return;
    }
    if(act==='start'){ state.screen='step'; state.i=0; render(); }
    else if(act==='close'){ close(); }
    else if(act==='restart'){ toIntro(); }
    else if(act==='back'){ if(state.screen==='results'){ state.screen='step'; state.i=STEPS.length-1; render(); } else { state.i--; render(); } }
    else if(act==='all'){ e.preventDefault(); state.showAll=true; results(); }
    else if(act==='less'){ e.preventDefault(); state.showAll=false; results(); }
  }

  /* ── Modal ───────────────────────────────────────────────────────────── */
  function build(){
    app = document.createElement('div');
    app.id = 'keuzehulp-app';
    app.innerHTML = '<div class="kh-overlay" data-overlay><div class="kh" role="dialog" aria-modal="true" aria-label="Keuzehulp koekenpan"></div></div>';
    document.body.appendChild(app);
    root = app.querySelector('.kh');
    root.addEventListener('click', onClick);
    app.querySelector('[data-overlay]').addEventListener('click', function(e){ if(e.target===e.currentTarget) close(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && app.classList.contains('is-open')) close(); });
  }
  function open(){
    lastFocus = document.activeElement;
    app.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    if(products===null && !loading) loadProducts();
    render();
  }
  function close(){
    app.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function init(){
    var mount = document.querySelector('[data-keuzehulp]');
    if(mount && mount.getAttribute('data-collection-handle')) handle = mount.getAttribute('data-collection-handle');
    build();
    Array.prototype.forEach.call(document.querySelectorAll('[data-keuzehulp-trigger]'), function(b){
      b.addEventListener('click', open);
    });
    if(new URLSearchParams(window.location.search).get('keuzehulp')==='open') open();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
